import { useTranslation } from 'react-i18next';
import React from 'react';

import Text, { ENUM_COLORS, ENUM_FONTS } from '@commons/Text';

import { INTEGRATION_STATUS_LABEL_KEYS } from '../../utils/constants';

import {
  Card,
  HeaderRow,
  IconWrapper,
  IntegrationStatusBadge,
  IntegrationStatusLabelHost,
  LogoAndTitle,
  LogoImage,
} from './styledComponents';

export const IntegrationCard = ({ integration, onOpenDetail }) => {
  const { t } = useTranslation();
  const { name, iconLetter, iconColor, logoUrl, status, description } = integration;

  const handleClick = () => {
    if (onOpenDetail) {
      onOpenDetail(integration);
    }
  };

  return (
    <Card
      $isClickable={Boolean(onOpenDetail)}
      role={onOpenDetail ? 'button' : undefined}
      onClick={handleClick}
    >
      <HeaderRow>
        <LogoAndTitle>
          {logoUrl ? (
            <LogoImage alt="" src={logoUrl} />
          ) : (
            <IconWrapper backgroundColor={iconColor}>{iconLetter}</IconWrapper>
          )}
          <Text font={ENUM_FONTS.H2_SLIM}>{name}</Text>
        </LogoAndTitle>
        {status && (
          <IntegrationStatusLabelHost>
            <IntegrationStatusBadge $status={status}>
              {t(INTEGRATION_STATUS_LABEL_KEYS[status])}
            </IntegrationStatusBadge>
          </IntegrationStatusLabelHost>
        )}
      </HeaderRow>
      <Text color={ENUM_COLORS.IP_BLACK_4} font={ENUM_FONTS.TEXT_INTER_REGULAR_12_HEIGHT_20}>
        {t(description)}
      </Text>
    </Card>
  );
};
